import Styles from "./main.module.css";
import Plogo1 from "../images/PlogoWhite.png";
import Error504Img from "../images/504 Error Gateway Timeout-cuate.png";
import { useEffect, useState } from "react";
export const Loading = ( props ) => {
    const { page, isLoaded } = props;
    const { Loading        } = Styles;
    const [ timeOut, setTimeOut ] = useState(false);
    const [ loaded, setLoaded ] = useState(false);
    useEffect(_=>{
        const timeInterval = setTimeout(_=>{
            setTimeOut(true);
            clearTimeout( timeInterval );
        }, 10000);
        const loadInterval = setInterval(_=>{
            if( isLoaded ){
                setLoaded( true );
                clearInterval( loadInterval );
                clearTimeout( timeInterval );
            }
        }, 1);
    }, [ isLoaded ]);
    return (
        <div className={ Loading } style={{ opacity: loaded ? "0" : "1" }}>
            <LoadElement timeOut={ timeOut } page={ page }/>
        </div>
    );
};
const Spinner        = ( props ) => {
    const {         } = props;
    const { Spinner } = Styles;
    return (
        <div className={ Spinner }></div>
    );
};
const Logo           = ( props ) => {
    const { icon, theme } = props;
    const { Logo        } = Styles;
    return (
        <div className={ Logo } style={{ color: theme ? theme : "white" }}>
            { icon }
        </div>
    );
};
const Plogo          = ( props ) => {
    const { logo  } = props;
    const { Plogo } = Styles;
    return (
        <div className={ Plogo }>
            <img src={ logo }/>
        </div>
    );
};
const Error504       = (props) => {
    const { Error504 } = Styles;
    return (
        <div className={Error504}>
            <div><img src={Error504Img} alt="504 Error"/></div>
            <h2>Gateway Timeout (504)</h2>
            <p>It seems the server is taking too long to respond. Please try refreshing the page or come back later.</p>
        </div>
    );
};
const LoadElement    = ( props ) => {
    const { timeOut, page } = props;
    const logoList = [
        { icon: <i className="bi bi-house-door-fill"></i>,      text: "Home",         theme: "#9C27B0" },
        { icon: <i className="bi bi-newspaper"></i>,            text: "Blogs",        theme: "#3F51B5" },
        { icon: <i className="bi bi-camera-reels-fill"></i>,    text: "Shorts",       theme: "#2196F3" },
        { icon: <i className="bi bi-collection-play-fill"></i>, text: "Courses",      theme: "#00BCD4" },
        { icon: <i className="bi bi-grid-fill"></i>,            text: "Products",     theme: "#009688" },
        { icon: <i className="bi bi-briefcase-fill"></i>,       text: "Projects",     theme: "#4caf50" },
        { icon: <i className="bi bi-backpack4-fill"></i>,       text: "Media",        theme: "#cddc39" },
        { icon: <i className="bi bi-person-vcard-fill"></i>,    text: "About Us",     theme: "#ff9800" },
        { icon: <i className="bi bi-diagram-3-fill"></i>,       text: "Contact Us",   theme: "#ff5722" },
        { icon: <i className="bi bi-stars"></i>,                text: "Gemini",       theme: "#795548" },
        { icon: <i className="bi bi-newspaper"></i>,            text: "View Blog",    theme: "#3F51B5" },
        { icon: <i className="bi bi-play-circle-fill"></i>,     text: "Video Player", theme: "#00bcd4" },
        { icon: <i className="bi bi-play-btn-fill"></i>,        text: "View Course",  theme: "#00bcd4" },
        { icon: <i className="bi bi-grid-1x2-fill"></i>,        text: "View List",    theme: "#e91e63" },
        { icon: <i className="bi bi-grid-1x2-fill"></i>,        text: "View Product", theme: "#009688" },
        { icon: <i className="bi bi-grid-1x2-fill"></i>,        text: "View Project", theme: "#4caf50" },
    ];
    return (
        <>
            {
                timeOut ? <Error504 /> :
                logoList.map(( value, key ) => {
                    const { icon, text, theme } = value;
                    return text === page && (
                        <Logo
                            icon  = { icon  }
                            theme = { theme }
                            key   = { key   }
                        />
                    );
                }) 
            }
        </>
    );
};
